import api from './axios';

// tipo = 'cliente' | 'sistema' — a API é a mesma para os dois
export const listar = (tipo, apenasAtivos = false) =>
  api.get(`/cadastros/${tipo}`, { params: { apenas_ativos: apenasAtivos } });

export const criar = (tipo, nome) => api.post(`/cadastros/${tipo}`, { nome });
export const atualizar = (tipo, id, dados) => api.patch(`/cadastros/${tipo}/${id}`, dados);
export const excluir = (tipo, id) => api.delete(`/cadastros/${tipo}/${id}`);
